const defaultEnvironment = require("./environment.default");

const ciEnvironment = {
  ...defaultEnvironment,
  development: true,
  serverUrl: 'https://demo-api.mexexec.dev/ecn-admin',
  serverPort: 443,
};
ciEnvironment.mexExchange.api.baseUrl = 'https://demo-api.mexexec.dev/ecn-admin';
ciEnvironment.mexExchange.websockets.url = 'https://demo-api.mexexec.dev/ecn-admin/ws';

export const environment = ciEnvironment;
